export function operacaoPostoManutencaoInRequest(params = {}) {
  return {
    type: '@operacaopostomanutencao/POSTOMANUTENCAO_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoPostoManutencao(poco_codigo) {
  return {
    type: '@operacaopostomanutencao/FIND_POSTOMANUTENCAO',
    payload: { poco_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaopostomanutencao/FAILED_REQUEST',
  };
}

export function deleteOperacaoPostoManutencao(poco_codigo, params) {
  return {
    type: '@operacaopostomanutencao/DELETE_POSTOMANUTENCAO',
    payload: { poco_codigo, params },
  };
}

export function updateOperacaoPostoManutencao(operacaopostomanutencao, params) {
  return {
    type: '@operacaopostomanutencao/UPDATE_POSTOMANUTENCAO',
    payload: { operacaopostomanutencao, params },
  };
}

export function storeOperacaoPostoManutencao(operacaopostomanutencao, params) {
  return {
    type: '@operacaopostomanutencao/STORE_POSTOMANUTENCAO',
    payload: { operacaopostomanutencao, params },
  };
}

export function successInRequest(
  operacaopostomanutencao,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaopostomanutencao/SUCCESS_IN_REQUEST',
    payload: { operacaopostomanutencao, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaopostomanutencao) {
  return {
    type: '@operacaopostomanutencao/SUCCESS_REQUEST',
    payload: { operacaopostomanutencao },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaopostomanutencao/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaopostomanutencao/RECORD_FILTERING',
    payload: { params },
  };
}
